export const DEBOUNCE_DELAY_MS = 500;
export const MIN_SEARCH_LENGTH = 3;
export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_DATE_RANGE_DAYS = 30;
